 

import baseApi from './baseApi';
import {
    EnvoyerFormulaireParCourrielCommand,
    FormulaireAddCommand,
    FormulaireDuplicateCommand,
    FormulairePourSignatureGetData,
    FormulaireRouteData,
    FormulairesGetData,
    FormulaireUpdateCommand,
    SubmitFormulaireCommand,
    SubmitFormulaireDemandeAdhesionCommand,
    SubmitFormulaireResult,
    SubmitDemandeAdhesionResult,
} from './Schemas/Formulaires';

const formulaireApi = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getAllFormulaires: builder.query<FormulairesGetData[], void>({
            query: () => `formulaire`,
            providesTags: (result, error) => {
                const tags = [{type: 'Formulaires', id: 'LIST'}] as { type: 'Formulaires', id: string }[];
                if (!error && result) {
                    for (const formulaire of result) {
                        tags.push({type: 'Formulaires', id: formulaire.id.toString()});
                    }
                }
                return tags;
            },
        }),
        getAllFormulairesRoutes: builder.query<FormulaireRouteData[], void>({
            query: () => `formulaire/routes`,
        }),
        getFormulaireById: builder.query<FormulairesGetData, number>({
            query: (id) => `formulaire/${id}`,
            providesTags: (_result, _error, args) => [{type: 'Formulaires', id: args}],
        }),
        addFormulaire: builder.mutation<void, FormulaireAddCommand>({
            query: (body) => ({
                url: `formulaire`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{type: 'Formulaires', id: 'LIST'}],
        }),
        getFormulaireByRoute: builder.query<FormulairePourSignatureGetData, {
            routeClient: string,
            routeFormulaire: string
        }>({
            query: (body) => `formulaire/par-route/${body.routeClient}/${body.routeFormulaire}`,
        }),
        updateFormulaire: builder.mutation<void, FormulaireUpdateCommand>({
            query: (body) => {

                const formData = new FormData();
                formData.append('Nom', body.nom);
                formData.append('Route', body.route);
                if (body.description) {
                    formData.append('Description', body.description);
                }
                if (body.titre) {
                    formData.append('Titre', body.titre);
                }
                formData.append('Id', body.id.toString());
                formData.append('PrimaryColor', body.primaryColor);
                formData.append('SecondaryColor', body.secondaryColor);
                if (body.introduction) {
                    formData.append('Introduction', body.introduction);
                }
                formData.append('Remerciement', body.remerciement);
                formData.append('SectionInfoPersonnelles', body.sectionInfoPersonnelles.toString());
                formData.append('SectionAdhesion', body.sectionAdhesion.toString());
                formData.append('SectionDemission', body.sectionDemission.toString());
                formData.append('SectionConsentements', body.sectionConsentements.toString());
                formData.append('AfficherLelienDeTelechargementALaFin', body.afficherLelienDeTelechargementALaFin.toString());
                formData.append('EnvoyerLeCourrielALaSoumission', body.envoyerLeCourrielALaSoumission.toString());
                formData.append('TitreSectionInfoSupplementaires', body.titreSectionInfoSupplementaires);
                formData.append('TitreSectionConsentement', body.titreSectionConsentement);
                formData.append('TitreSectionDemission', body.titreSectionDemission);
                formData.append('TitreSectionAdhesion', body.titreSectionAdhesion);
                formData.append('TitreSectionDonneesPersonnelles', body.titreSectionDonneesPersonnelles);

                formData.append('SectionVerificationCourriel', body.sectionVerificationCourriel.toString());
                formData.append('TitreSectionVerificationCourriel', body.titreSectionVerificationCourriel);

                formData.append('SujetCourrielALaSoumission', body.sujetCourrielALaSoumission?.toString() ?? '');
                formData.append('TemplateCourrielALaSoumission', body.templateCourrielALaSoumission?.toString() ?? '');
                formData.append('SujetCourrielPourLeLien', body.sujetCourrielPourLeLien?.toString() ?? '');
                formData.append('TemplateCourrielPourLeLien', body.templateCourrielPourLeLien?.toString() ?? '');

                formData.append('PaymentRequired', body.paymentRequired.toString());
                formData.append('PaymentAmount', body.paymentAmount?.toString() ?? '');
                formData.append('PaymentStepTitle', body.paymentStepTitle ?? '');
                formData.append('PaymentStepDescription', body.paymentStepDescription ?? '');
                formData.append('AllowExternalPayment', body.allowExternalPayment.toString());
                formData.append('AllowDeferredPayment', body.allowDeferredPayment.toString());

                if (body.banniere) {
                    formData.append('Banniere', body.banniere);
                }


                return ({
                    url: `formulaire`,
                    method: 'PUT',
                    body: formData,
                });
            },
            invalidatesTags: (_result, _error, args) => [{type: 'Formulaires', id: 'LIST'}, {
                type: 'Formulaires',
                id: args.id.toString(),
            }],
        }),

        duplicateFormulaire: builder.mutation<void, FormulaireDuplicateCommand>({
            query: (body) => ({
                url: `formulaire/duplicate`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{type: 'Formulaires', id: 'LIST'}],

        }),

        deleteFormulaire: builder.mutation<void, number>({
            query: (id) => ({
                url: `formulaire/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_result, _error, args) => [{type: 'Formulaires', id: 'LIST'}, {
                type: 'Formulaires',
                id: args.toString(),
            }],

        }),

        soumettreFormulaire: builder.mutation<SubmitFormulaireResult, SubmitFormulaireCommand>({
            query: ({...body}) => ({
                url: 'formulaire/soumettre',
                method: 'POST',
                body,
            }),
        }),

        soumettreDemandeAdhesion: builder.mutation<SubmitDemandeAdhesionResult, SubmitFormulaireDemandeAdhesionCommand>({
            query: ({...body}) => ({
                url: 'formulaire/demande-adhesion',
                method: 'POST',
                body,

            }),
        }),

        envoyerFormulaireParCourriel: builder.mutation<void, EnvoyerFormulaireParCourrielCommand>({
            query: ({...body}) => ({
                url: 'formulaire/envoyer-courriel',
                method: 'POST',
                body,
            }),
        }),


    }),

});

export const {
    useGetAllFormulairesQuery,
    useGetFormulaireByIdQuery,
    useAddFormulaireMutation,
    useUpdateFormulaireMutation,
    useGetFormulaireByRouteQuery,
    useSoumettreFormulaireMutation,
    useSoumettreDemandeAdhesionMutation,
    useGetAllFormulairesRoutesQuery,
    useDeleteFormulaireMutation,
    useDuplicateFormulaireMutation,
    useEnvoyerFormulaireParCourrielMutation,
} = formulaireApi;


export default formulaireApi;
